import type { IFeatureIslandCategoriesAndManagerStore } from "@/components/features/_layouts/island/main-with-category/store";
import { createFeatureIslandCategoryStore } from "@/components/features/_layouts/island/main-with-category/store/category";
import { createFeatureIslandCategoryManagerStore } from "@/components/features/_layouts/island/main-with-category/store/category-manager";

export class StandardRoomCategoriesAndManagerStore implements IFeatureIslandCategoriesAndManagerStore {
	// 基本設定
	public base = createFeatureIslandCategoryStore({
		title: "部屋名・画像",
		description: "部屋に関する基本的な設定を行う項目です",
		isBasicSetup: true,
	});

	public priceAndStockAndPolicy = createFeatureIslandCategoryStore({
		title: "定員・在庫・ポリシー",
		description: "",
		isBasicSetup: true,
	});

	public connection = createFeatureIslandCategoryStore({
		title: "プラン制限・紐付け",
		description: "",
		isBasicSetup: true,
	});

	// ここから下は 「追加設定」isBasicSetup: false
	public discountSetting = createFeatureIslandCategoryStore({
		title: "ディスカウントの適用設定",
		description: "",
		isBasicSetup: false,
	});

	public salesTerm = createFeatureIslandCategoryStore({
		title: "販売期間",
		description: "",
		isBasicSetup: false,
	});

	public roomDetailInfo = createFeatureIslandCategoryStore({
		title: "部屋の詳細情報",
		description: "",
		isBasicSetup: false,
	});

	public address = createFeatureIslandCategoryStore({
		title: "部屋ごとの住所",
		description: "",
		isBasicSetup: false,
	});

	public dormitory = createFeatureIslandCategoryStore({
		title: "ドミトリー設定",
		description: "",
		isBasicSetup: false,
	});

	public advancedPricing = createFeatureIslandCategoryStore({
		title: "高度な料金設定",
		description: "",
		isBasicSetup: false,
	});

	public categoryStoreArray = [
		this.base,
		this.priceAndStockAndPolicy,
		this.connection,
		this.discountSetting,
		this.salesTerm,
		this.roomDetailInfo,
		this.address,
		this.dormitory,
		this.advancedPricing,
	];

	public categoryManagerStore = createFeatureIslandCategoryManagerStore({
		items: this.categoryStoreArray,
	});
}

export const standardRoomCategoriesAndManagerStore = new StandardRoomCategoriesAndManagerStore();
